import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@api/types';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { TokenService } from '@shared/services/token.service';
import { ZendeskConfig } from '@shared/types/zendesk';
import { get } from 'lodash';
import { NgxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';

@Component({
  selector: 'rav-account-info',
  templateUrl: './account-info.component.html',
  styleUrls: ['./account-info.component.scss']
})
export class AccountInfoComponent implements OnDestroy {
  user: User;
  fullName: string;
  initializedZendesk = false;

  constructor(
    public localStorage: LocalStorageService,
    private token: TokenService,
    public router: Router,
    private zenDesk: NgxZendeskWebwidgetService
  ) {
    this.user = this.localStorage.userWithToken;
  }

  ngOnDestroy(): void {
    if (this.initializedZendesk) this.zenDesk.zE('webWidget', 'hide');
  }

  /**
   * Logs the user out of the app by revoking their access.
   */
  async logout() {
    await this.token.revokeAccessAndLogout();
  }

  /**
   * Launches different account view depending on if we are in back office or main application
   */
  launchAccount() {
    if (this.router.url.includes('/admin')) this.router.navigateByUrl('/admin/settings');
    else this.router.navigateByUrl('/account');
  }

  /**
   * When the help button is clicked, the ZenDesk web widget is launched
   */
  async onHelpClick() {
    if (!this.initializedZendesk) await this.initZendesk();
    this.zenDesk.zE('webWidget', 'show');
    this.zenDesk.zE('webWidget', 'open');
  }

  /**
   * Initializes the Zendesk service and identifies the user by adding name, email, and organization.
   */
  async initZendesk(): Promise<void> {
    await this.zenDesk.initZendesk(new ZendeskConfig());
    this.zenDesk.zE('webWidget', 'identify', {
      name: `${get(this.localStorage, 'userWithToken.first_name', '')}  ${get(
        this.localStorage,
        'userWithToken.last_name',
        ''
      )}`,
      email: get(this.localStorage, 'userWithToken.email', ''),
      organization: get(this.localStorage, 'userWithToken.account.name', '')
    });
    this.initializedZendesk = true;
  }
}
